<!--修改密码-->
<template>
    <div class="el-editPassword">
        <el-row class="page_content">
            <h1 class="head_title">修改密码</h1>
            <el-row style="width:40%;min-width:400px;">
                 <el-form ref="ruleForm" :rules="rules" :model="ruleForm" label-width="130px">
                      <el-form-item label="用户名：">
                       <!-- style="border-bottom: 1px solid #DCDFE6;padding-left: 10px;display: block;" -->
                       <span>
                            {{studentInfo.studentName}}
                       </span>
                      </el-form-item>
                      <el-form-item prop="pwd" label="原密码：">
                        <el-input v-model="ruleForm.pwd" show-password></el-input>
                      </el-form-item>
                      <el-form-item prop="pwd1" label="新密码：">
                        <el-input v-model="ruleForm.pwd1" show-password></el-input>
                      </el-form-item>
                      <el-form-item prop="pwd2" label="确认密码：">
                        <el-input v-model="ruleForm.pwd2" show-password></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="onSubmit('ruleForm')" :loading="submitBut">修 改</el-button>
                        <span style="font-size: 13px;color: red;margin-left: 20px;">密码8位以上，包含大小写字母，特殊字符，数字</span>
                    </el-form-item>
                 </el-form>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import {getStudentInfoKeyForRoleTag} from "../../common/ulit";

export default {
  name: "EditPassword",
  data() {
    var validatePass = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入密码'));
    } else {
        if (this.ruleForm.pwd !== '') {
        this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
    }
    };
    var validatePass1 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请输入新密码'));
    } else {
        if (this.ruleForm.pwd1 !== '') {
        this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
    }
    };
    var validatePass2 = (rule, value, callback) => {
    if (value === '') {
        callback(new Error('请再次输入密码'));
    } else if (value !== this.ruleForm.pwd1) {
        callback(new Error('两次输入密码不一致!'));
    } else {
        callback();
    }
    };
    return {
        submitBut:false,
        ruleForm:{
            pwd:"",
            pwd1:"",
            pwd2:""
        },
        rules: {
          pwd: [
            { validator: validatePass, trigger: 'blur' }
          ],
          pwd1: [
            { validator: validatePass1, trigger: 'blur' }
          ],
          pwd2: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        },
        submitBut:false,
        studentInfo:JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag()))
    };
  },
  created() {

  },
  methods: {
    onSubmit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitBut = true;
            this.$store.dispatch("user/editPassword", {
                oldStudentPassword:this.ruleForm.pwd,
                secondStudentPassword:this.ruleForm.pwd2,
                studentPassword:this.ruleForm.pwd1
              })
              .then((ret) => {
                this.$message({
                   message: ret.msg,
                   type: ret.code == 0?"success":'warning'
                });
                this.submitBut = false;
              }).catch(() => {
                this.submitBut = false;
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-editPassword{
    .el-form-item__label,.el-form-item__content{
        font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/EditPassword.vue